module.exports = __webpack_public_path__ + "img/pay-wechat.f1126915.svg";